import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-fourteen',
  templateUrl: './home-page-fourteen.component.html',
  styleUrls: ['./home-page-fourteen.component.scss']
})
export class HomePageFourteenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
